import React, { useRef } from "react";
import { Badge, Tabs } from "antd";
import ReceivingRubberList from "../components/receiving-latex/ReceivingLatexList";
import DailyPurchasingPriceList from "../components/receiving-latex/DailyPurchasingPriceList";
import ConditionsOfPurchaseList from "../components/receiving-latex/ConditionsOfPurchaseList";
import { GET } from "../frameworks/HttpClient";
import { URL_TRUCK } from "../constants/urls";
import _ from "lodash";
// import { USER_GROUP } from "../constants/string";
// import { useUserContext } from "../hooks/UserSettingProvider";

export default function ReceivingLatexView() {
  const tableRef = useRef(null);
  const [hasLabCount, setHasLabCount ]= React.useState();
  // const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? (user.groups.find((group) => group === target) ? true : false) : true)

  const fetchTruckHasLabResults = async() => {
    try {
      const response = await GET(URL_TRUCK.TRUCK_TRANSACTION_STATUS)
      setHasLabCount(_.get(response, 'data.done_lab_count', 0))
    } catch (error) {
      console.log(error)
    }
  }

  const tabItems = [
    {
      key: "pending",
      label: <>กำลังดำเนินการ <Badge count={hasLabCount} offset={[3 ,-2]} /></>,
      children: <ReceivingRubberList total={false} ref={tableRef} fetchHasLab={() => fetchTruckHasLabResults()}/>,
      permissions : true,
    },
    {
      key: "total",
      label: "รถเข้าทั้งหมด",
      children: <ReceivingRubberList total={true} ref={tableRef} fetchHasLab={() => fetchTruckHasLabResults()}/>,
      permissions : true,
    },
    {
      key: "DailyPurchasingPrice",
      label: "ราคารับซื้อประจำวัน",
      children: <DailyPurchasingPriceList ref={tableRef} />,
      permissions : true,
    },
    {
      key: "ConditionsOfPurchase",
      label: "เงื่อนไขการรับซื้อ",
      children: <ConditionsOfPurchaseList ref={tableRef} />,
      permissions : true,
    },
  ];

  React.useEffect(() => {
    fetchTruckHasLabResults();
  },[])

  React.useEffect(() => {
    const interval = setInterval(() => {
      fetchTruckHasLabResults();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="pending"
        items={tabItems.filter((item) => item.permissions == true)}
      />
    </div>
  );
}
